var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('h1',[_vm._v("Access denied")]),_c('button',{on:{"click":_vm.logOut}},[_vm._v("Sign out")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }